const VIEWPORT_VARIABLE = 'vh'

function setViewportProperty(document: HTMLElement) {
  let previousClientHeight: number
  const customVar = '--' + (VIEWPORT_VARIABLE || 'vh')

  function handleResize() {
    const clientHeight = document.clientHeight
    if (clientHeight === previousClientHeight) return

    requestAnimationFrame(() => {
      document.style.setProperty(customVar, clientHeight * 0.01 + 'px')
      previousClientHeight = clientHeight
    })
  }
  handleResize()
  return handleResize
}

if (window) {
  window.addEventListener(
    'resize',
    setViewportProperty(document.documentElement)
  )
}

export {}
